import { createSlice } from '@reduxjs/toolkit';
import { CollectionActivityWithUser } from '@dill/dill-shared';
import {
  getBuyerCollectionActivitiesExtraReducer,
  getSupplierCollectionActivitiesExtraReducer,
  getSupplierCollectionTasksExtraReducer,
  createCollectionActivityExtraReducer,
  updateCollectionActivityExtraReducer,
  deleteCollectionActivityExtraReducer,
  decideTaxExemptReviewTasksExtraReducer,
} from '../reducers/collectionActivityReducers';

export interface CollectionActivityInitialState {
  loadingList: string[];
  error: string | null;
  buyerActivities: CollectionActivityWithUser[];
  supplierActivities: CollectionActivityWithUser[];
  supplierTasks: CollectionActivityWithUser[];
}

const initialState: CollectionActivityInitialState = {
  loadingList: [],
  error: null,
  buyerActivities: [],
  supplierActivities: [],
  supplierTasks: [],
};

export const collectionActivitySlice = createSlice({
  name: 'collectionActivities',
  initialState,
  reducers: {
    resetCollectionActivityRootState: () => initialState,
    clearBuyerActivities: (state) => {
      state.buyerActivities = [];
    },
  },
  extraReducers(builder) {
    getBuyerCollectionActivitiesExtraReducer(builder);
    getSupplierCollectionActivitiesExtraReducer(builder);
    getSupplierCollectionTasksExtraReducer(builder);
    createCollectionActivityExtraReducer(builder);
    updateCollectionActivityExtraReducer(builder);
    deleteCollectionActivityExtraReducer(builder);
    decideTaxExemptReviewTasksExtraReducer(builder);
  },
});

export const { resetCollectionActivityRootState, clearBuyerActivities } =
  collectionActivitySlice.actions;
